import React from 'react';

import IncentiveNewUpdate from 'components/Tvendo/Commissions/Operations/Incentive/Maintenance/Incentive/IncentiveNewUpdate.js';

export default function () {
  return <IncentiveNewUpdate />;
}
